import { createContext, type ReactNode } from "react";

export type LayoutPageChrome = {
  hideBackButton?: boolean;
  hidePageHeader?: boolean;
  /** Aktionen rechts neben dem Seitentitel der Einstellungsseite, z. B. Speichern. */
  headerExtra?: ReactNode;
  /** Inhalt über die ganze Fensterbreite statt der Standard-Höchstbreite (Raster-Arbeitsflächen). */
  fullWidth?: boolean;
};

/** Gemeinsame, stabile Einstellung für Rasterseiten (Kalender, Dienstplan, Verfügbarkeiten). */
export const FULL_WIDTH_PAGE_CHROME: LayoutPageChrome = { fullWidth: true };

export type LayoutPageChromeContextValue = {
  setPageChrome: (chrome: LayoutPageChrome | null) => void;
};

export const LayoutPageChromeContext = createContext<LayoutPageChromeContextValue>({
  setPageChrome: () => {},
});
